import React from 'react';
import { motion } from 'framer-motion';
import Container from './ui/Container';
import Button from './ui/Button';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function Hero({ content }) {
  const { headline, subheadline, trustLine, primaryCTA } = content;

  return (
    <section className="relative py-24 sm:py-32 bg-white overflow-hidden">
      <div className="absolute inset-0 z-0 opacity-[0.03] bg-[radial-gradient(#0f172a_1px,transparent_1px)] [background-size:16px_16px]"></div>
      
      <Container className="relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <div className="flex items-center justify-center gap-2 text-xs font-semibold tracking-wider text-slate-500 uppercase mb-8">
             <SafeIcon icon={FiIcons.FiShield} className="w-4 h-4" />
             <span>{trustLine}</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900 mb-6 max-w-4xl mx-auto leading-[1.1]">
            {headline}
          </h1>

          <p className="text-lg sm:text-xl text-slate-600 max-w-2xl mx-auto mb-10 leading-relaxed">
            {subheadline}
          </p>

          <Button 
            href="#demos"
            variant="primary" 
            className="min-w-[200px]"
          >
            {primaryCTA}
          </Button>
        </motion.div>
      </Container>
    </section>
  );
}